
import Group from 'vux/src/components/group/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import dateFormat from 'vux/src/tools/date/format.js'

import global from '../../../static/js/global'
import loadPage from '../../components/loadingPage'
export default {
name: "orderDetail",
components:{
Group,
Flexbox,
FlexboxItem,
XButton,
XTextarea,
global,
Alert,
dateFormat,
loadPage
},
data(){
return{
info:'',
evaluate:false,
remark:'非常满意',
greads:"5.0",
dataList:{},
hides:false,
hides1:false,
hides2:false,
hides3:false,
hides4:false,
hides5:false,
hides6:false,
hides7:false,
hides8:false,
repirds:"",
showAlert:false,
datays:"",
his:false,
evaluateTime:""
}
},
beforeMount(){
this.show_1 = true;
let repairIds = this.$router.history.current.query.repairId;
this.$http.get(global.host + '/repair/findredetail?repairId='+repairIds).then(function(res){
this.show_1 = false;
let datay = res.body;
this.dataList = new Object();
this.repirds = res.body.result.repairId;
console.log(datay);
for(let ks in datay){
if(typeof(ks) == "object"){
for(let ms in ks){
this.dataList[ms] = ks[ms];
}
}else{
this.dataList[ks] = datay[ks];
}
}
let codeId = res.body.result.repairState;
if(codeId == '0'){
this.hides = true;

}else if(codeId == '1'){
this.hides = true;
this.hides1 = true;
this.hides2 = true;
}else if(codeId == '2'){
this.hides = true;
this.hides1 = true;
this.hides2 = true;
this.hides3 = true;
this.hides4 = true;
}else if(codeId == '3'){
this.hides = true;
this.hides1 = true;
this.hides2 = true;
this.hides3 = true;
this.hides4 = true;
this.hides5 = true;
this.hides6 = true;
this.his = true;
}else if(codeId == '4'){
this.hides = true;
this.hides1 = true;
this.hides2 = true;
this.hides3 = true;
this.hides4 = true;
this.hides5 = true;
this.hides6 = true;
this.hides7 = true;
this.hides8 = true;
this.evaluateTime = dateFormat(new Date(), 'YYYY-MM-DD HH:mm:ss');
}

},function(err){
console.log(err)
})
},
methods:{
submitData(){
let usrsInfo = new Object();
usrsInfo.repairId = this.repirds;
usrsInfo.scoreLevel = this.greads;
usrsInfo.scoreDesc = this.info;
console.log(usrsInfo)
let urls = global.host + '/repair/updevaluate';
this.$http.post(urls,usrsInfo).then(function(res){
this.datays = res.body.msg;
if(res.body.msgcode == "110"){
this.showAlert = true;
this.his = false;
this.evaluate = false;
this.evaluateTime = dateFormat(new Date(), 'YYYY-MM-DD HH:mm:ss');
this.hides7 = true;
this.hides8 = true;
}

},function(err){
console.log(err)
})
},
showevaluate(){
this.evaluate = true
},

hideevaluate(){
this.evaluate = false
},

changeStyle(id){
let classList = document.getElementById(id).classList;
if(classList.contains('weui-btn_primary')){
classList.remove('weui-btn_primary');
}else{
classList.add('weui-btn_primary');
}
},

preference(index){
switch ( parseInt(index)){
case 1:
this.remark = '非常不满意';
this.greads = "1";
break;
case 2:
this.remark = '比较不满意';
this.greads = "2";
break;
case 3:
this.remark = '一般满意';
this.greads = "3";
break;
case 4:
this.remark = '比较满意';
this.greads = "4";
break;
case 5:
this.remark = '非常满意';
this.greads = "5";
break;

}
let child = document.getElementById('favorite').children;
for(let j = 0;j< 5 ; j++){
if(child[j].classList.contains('icon-ai-mark')){
child[j].classList.remove('icon-ai-mark')
child[j].classList.add('icon-shoucang')
}
}
for(let i = 0 ; i< parseInt(index) ; i++){
if(child[i].classList.contains('icon-shoucang')){
child[i].classList.remove('icon-shoucang')
child[i].classList.add('icon-ai-mark')
}
}
}


}
}



// WEBPACK FOOTER //
// ./src/components/repairComponents/orderDetail.vue